import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { focusRing, hoverable, pressable } from '@/shared/design-system';
import { SUI_ICON_COLOR } from '@/shared/modules/wallet/colors';

export const Root = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[4],
  padding: theme.spacing[4],
  borderRadius: theme.radius[8],
  backgroundColor: theme.colors.neutral.solid,
  textDecoration: 'none',

  ...hoverable(theme, 'surfaceRaised'),
  ...pressable(theme, 'surfaceRaised'),
  ...focusRing(theme),
}));

export const ValueSlot = styled('span')({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  width: 84,
  minWidth: 0,
});

export const Glyph = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 24,
  height: 24,
  padding: theme.spacing[2],
  boxSizing: 'border-box',
  borderRadius: theme.radius[6],
  backgroundColor: SUI_ICON_COLOR,
  color: theme.colors.text.primary,

  svg: {
    width: '100%',
    height: '100%',
    color: 'inherit',
  },
}));
